// extracted by mini-css-extract-plugin
export default {"fields":"IdentityProviderSettingsFields_fields__mdH15","textarea":"IdentityProviderSettingsFields_textarea__O7kqc"};